import { api } from '../clients';
import type { SideBarAPIResult } from '../types';

async function fetchActivities() {
  try {
    const { data: final_data } = await api.get<SideBarAPIResult>(
      '/get-all-sidebar-activities.php'
    );

    return final_data;
  } catch (err) {
    return Promise.reject(err);
  }
}

export default fetchActivities;
